import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as lookups from './lookups';
import * as AllMutates from './AllMutates';

export function addAttachment(data, errorType) {
	return dispatch => Api.postData('attachments/', data).then(resp => dispatch(lookups.activeVehicle(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateAttachment(id, data, errorType) {
	return dispatch => Api.patchData(`attachments/${id}`, data).then(resp => dispatch(lookups.activeVehicleWithPromise(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function addCatalogPartAttachmentRaw(data) {
	return () => Api.postData('attachments/', data);
}

export function addCatalogPartAttachment(data, errorType) {
	return dispatch => Api.postData('attachments/', data).then(() => dispatch(getInfo.getCatalogParts())).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateCatalogPartAttachment(id, data, errorType) {
	return dispatch => Api.patchData(`attachments/${id}`, data).then(() => dispatch(getInfo.getCatalogParts())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteCatalogPartAttachment(id, errorType) {
	return dispatch => Api.delete(`attachments/${id}`).then(() => dispatch(getInfo.getCatalogParts())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteAttachment(id, errorType) {
	return dispatch => Api.delete(`attachments/${id}`).then(() => 'success').catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteAttachmentWithRefresh(vehicle_id, id, errorType) {
	return dispatch => Api.delete(`attachments/${id}`).then(resp => dispatch(lookups.activeVehicle(vehicle_id))).then(() => 'success').catch(ex => Api.handleApiError(ex, errorType));
}
